import TomSelect from "tom-select";
import BInput from "../../Modules/BInput";
import BRequest from "../../Modules/BRequest";

export default class BSelect
{
	static selector = () => `.b-select`;

	static initialize()
	{
		document.querySelectorAll(this.selector()).forEach(el => {
			let options = {
				onFocus: () => {
					new BInput(el.closest(`.b-input`)).setFocused();
				},
				onBlur: () => {
					new BInput(el.closest(`.b-input`)).unsetFocused();
				},
				render: {
					loading: (data, escape) => `<div class="no-results">Načítám&hellip;</div>`,
					no_results: (data, escape) => `<div class="no-results">Nic nenalezeno.</div>`,
				},
			};

			// Close dropdown after selection for non-multiple selects
			if (!el.multiple) {
				options.closeAfterSelect = true;
			}

			if (el.dataset?.remoteDatasource) {
				options.load = (query, callback) => {
					BRequest.get(el.dataset.remoteDatasource, {
						query: query,
					}).then(response => {
						let items = response.data;
						items.map(item => {
							if (!item?.text) {
								item.text = item?.label;
							}
						});
						callback(items);
					});
				}
				options.delimiter = ";;;";
			}

			let widget = new TomSelect(el, options);
		});
	}
}
